import { render, staticRenderFns } from "./FollowList.vue?vue&type=template&id=bd4cc482&scoped=true"
import script from "./FollowList.vue?vue&type=script&lang=js"
export * from "./FollowList.vue?vue&type=script&lang=js"
import style0 from "./FollowList.vue?vue&type=style&index=0&id=bd4cc482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4cc482",
  null
  
)

export default component.exports